export function createWorkflowOrchestratorClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/workflows
         *
         * Requires scope: workflows:start
         */
        startWorkflow(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/workflows/{workflowId}
         *
         * Requires scope: workflows:read
         */
        getWorkflow(tenantId, workflowId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows/${encodeURIComponent(workflowId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/workflows/{workflowId}/signals
         *
         * Requires scope: workflows:signal
         */
        signalWorkflow(tenantId, workflowId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows/${encodeURIComponent(workflowId)}/signals`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/workflows/{workflowId}/cancellations
         *
         * Requires scope: workflows:cancel
         */
        cancelWorkflow(tenantId, workflowId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows/${encodeURIComponent(workflowId)}/cancellations`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/workflows/{workflowId}/activities
         *
         * Requires scope: workflow-activities:schedule
         */
        scheduleWorkflowActivity(tenantId, workflowId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows/${encodeURIComponent(workflowId)}/activities`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/activity-leases
         *
         * Requires scope: workflow-activities:work
         */
        leaseActivity(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/activity-leases`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/activities/{activityId}/heartbeats
         *
         * Requires scope: workflow-activities:work
         */
        heartbeatActivity(tenantId, activityId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/activities/${encodeURIComponent(activityId)}/heartbeats`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/activities/{activityId}/completions
         *
         * Requires scope: workflow-activities:work
         */
        completeActivity(tenantId, activityId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/activities/${encodeURIComponent(activityId)}/completions`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/workflows/{workflowId}/timers
         *
         * Requires scope: workflow-timers:schedule
         */
        scheduleWorkflowTimer(tenantId, workflowId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/workflows/${encodeURIComponent(workflowId)}/timers`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/due-timers/process
         *
         * Requires scope: workflow-timers:process
         */
        processDueWorkflowTimers(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/due-timers/process`,
                body,
                options,
            });
        },
        /**
         * List every tenant's workflow executions, as an identity, a state and two cells
         *
         * Requires scope: workflows:platform:read
         */
        listPlatformWorkflows(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/workflows",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=workflow-orchestrator.js.map